<template>
  <div class="freshness-chip" :class="'freshness-' + state" :title="tooltipText">
    <span class="freshness-dot"></span>
    <span class="freshness-label">{{ label }}</span>
  </div>
</template>

<script>
import { getDataFreshnessLabel } from '@/services/entra-utils.js';

export default {
  name: 'DataFreshnessChip',
  props: {
    state: { type: String, default: 'fresh' },
    collectedAt: { type: String, default: '' }
  },
  computed: {
    label: function() { return getDataFreshnessLabel(this.state); },
    tooltipText: function() {
      if (this.collectedAt) return this.label + ' - Last collected: ' + this.collectedAt;
      return this.label;
    }
  }
};
</script>

<style scoped>
.freshness-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 0.6875rem;
  font-weight: 600;
}

.freshness-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.freshness-fresh { background: #f0fdf4; color: #166534; }
.freshness-fresh .freshness-dot { background: #16a34a; }

.freshness-delayed { background: #fefce8; color: #854d0e; }
.freshness-delayed .freshness-dot { background: #ca8a04; }

.freshness-stale { background: #fef2f2; color: #991b1b; }
.freshness-stale .freshness-dot { background: #dc2626; }

.freshness-failed { background: #fef2f2; color: #991b1b; }
.freshness-failed .freshness-dot { background: #dc2626; }

.freshness-never-collected { background: #f9fafb; color: #475569; }
.freshness-never-collected .freshness-dot { background: #6b7280; }

.freshness-partial { background: #fefce8; color: #854d0e; }
.freshness-partial .freshness-dot { background: #ca8a04; }
</style>
